import { render, staticRenderFns } from "./setpasswd.vue?vue&type=template&id=46e371ce&scoped=true"
import script from "./setpasswd.vue?vue&type=script&lang=js"
export * from "./setpasswd.vue?vue&type=script&lang=js"
import style0 from "./setpasswd.vue?vue&type=style&index=0&id=46e371ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e371ce",
  null
  
)

export default component.exports